import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href="https://wa.me/919638063350?text=Hi%20I%20am%20interested%20in%20your%20services"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl px-6 py-4"
      >
        <MessageCircle size={24} />
        <span className="hidden sm:block font-semibold">Chat with Us</span>
      </a>
    </div>
  );
};

export default WhatsAppButton;
